import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeExercicioConsultaListaIndicadoresPlanejamentoEstrategico: [],
    removePlanoEstrategicoConsultaListaIndicadoresPlanejamentoEstrategico: [],
    removeTemaConsultaListaIndicadoresPlanejamentoEstrategico: [],
    removeObjetivoEstrategicoConsultaListaIndicadoresPlanejamentoEstrategico: [],
    removeUnidadeMedidaConsultaListaIndicadoresPlanejamentoEstrategico: [],
    setMostraAplicarFiltroConsultaListaIndicadoresPlanejamentoEstrategico: [],
    limpaFiltroConsultaListaIndicadoresPlanejamentoEstrategico: [],
    aplicarFiltroConsultaListaIndicadoresPlanejamentoEstrategico: ['filtro'],
})

const INITIAL_STATE = {
    exercicio: [],
    planoEstrategico: [],
    tema: [],
    objetivoEstrategico: [],
    unidadeMedida: [],
    mostraAplicarFiltro: false,
    status: '',
}

const removeExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: '', mostraAplicarFiltro: true }
}

const removePlanoEstrategico = (state = INITIAL_STATE, action) => {
    state.planoEstrategico.splice(state.planoEstrategico.indexOf(action.planoEstrategico), 1)
    state.planoEstrategico = Array.from(state.planoEstrategico)
    return { ...state, mostraAplicarFiltro: true }
}

const removeTema = (state = INITIAL_STATE, action) => {
    state.tema.splice(state.tema.indexOf(action.tema), 1)
    state.tema = Array.from(state.tema)
    return { ...state, mostraAplicarFiltro: true }
}

const removeObjetivoEstrategico = (state = INITIAL_STATE, action) => {
    state.objetivoEstrategico.splice(state.objetivoEstrategico.indexOf(action.objetivoEstrategico), 1)
    state.objetivoEstrategico = Array.from(state.objetivoEstrategico)
    return { ...state, mostraAplicarFiltro: true }
}

const removeUnidadeMedida = (state = INITIAL_STATE, action) => {
    state.unidadeMedida.splice(state.unidadeMedida.indexOf(action.unidadeMedida), 1)
    state.unidadeMedida = Array.from(state.unidadeMedida)
    return { ...state, mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_EXERCICIO_CONSULTA_LISTA_INDICADORES_PLANEJAMENTO_ESTRATEGICO]: removeExercicio,
    [Types.REMOVE_PLANO_ESTRATEGICO_CONSULTA_LISTA_INDICADORES_PLANEJAMENTO_ESTRATEGICO]: removePlanoEstrategico,
    [Types.REMOVE_TEMA_CONSULTA_LISTA_INDICADORES_PLANEJAMENTO_ESTRATEGICO]: removeTema,
    [Types.REMOVE_OBJETIVO_ESTRATEGICO_CONSULTA_LISTA_INDICADORES_PLANEJAMENTO_ESTRATEGICO]: removeObjetivoEstrategico,
    [Types.REMOVE_UNIDADE_MEDIDA_CONSULTA_LISTA_INDICADORES_PLANEJAMENTO_ESTRATEGICO]: removeUnidadeMedida,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_LISTA_INDICADORES_PLANEJAMENTO_ESTRATEGICO]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_CONSULTA_LISTA_INDICADORES_PLANEJAMENTO_ESTRATEGICO]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_LISTA_INDICADORES_PLANEJAMENTO_ESTRATEGICO]: aplicarFiltro,
})
